// @flow
import React, { type Node } from 'react';
import { t, addTranslationKeys } from 'Src/i18n';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { ICONS } from 'Components/utils/icon/icons';

import { ProductService, type Service } from './product-service/ProductService';

export type Props = {
  allInclusiveServices: $ReadOnlyArray<Service>,
  config: CMSContent,
};

export const ProductServices = ({ allInclusiveServices, config }: Props): Node => {
  addTranslationKeys(config);

  const style =
    '.ProductServices-serviceContainer:last-child .border-b-1 {border-width: 0;} @media (min-width: 64.01em) {.ProductServices-serviceContainer:nth-last-child(-n+2) .border-b-1 {border-width: 0}}';

  if (allInclusiveServices.length === 0) {
    return null;
  }

  return (
    <div className="border-1 pt-6 px-5 lg:px-10 rounded-tiny border-gray-medium">
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="text-blue font-brand flex justify-center items-center text-2xl">
        <Icon name={ICONS.ALL_INCLUSIVE} width="calc(27rem / 16)" />
        <span className="rtl:ml-3 leading-one">{t('common.allInclusive')}</span>
      </div>
      <div className="flex flex-wrap justify-between md:py-3 ProductServices-list">
        {allInclusiveServices.map((service, index) => {
          return (
            <div className="w-full lg:w-12/25 ProductServices-serviceContainer" key={service.label}>
              <ProductService
                service={service}
                disableBorder={index === allInclusiveServices.length - 1}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
